module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_copy_black-85d3e806bb3a9bbf36dc3fa9bf99c1b8.svg";